module.exports = __webpack_public_path__ + "img/6aa906f.png";